import { render, staticRenderFns } from "./ListGroup.vue?vue&type=template&id=40b0e3d8&"
import script from "./ListGroup.vue?vue&type=script&lang=js&"
export * from "./ListGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports